import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import frFR from "antd/es/locale/fr_FR";
import enGB from "antd/es/locale/en_GB";
import arEG from "antd/es/locale/ar_EG";
import { getLanguage, languageInfo } from "./index";
import { loadCurrency } from "./currency";

const ANTD = { fr: frFR, en: enGB, ar: arEG };

/** Root of the app: antd texts (pickers, pagination, empty tables…) and direction in the user's language. */
export default function I18nProvider({ children }) {
  useEffect(() => {
    loadCurrency();
  }, []);
  return (
    <ConfigProvider locale={ANTD[getLanguage()] || frFR} direction={languageInfo().dir}>
      {children}
    </ConfigProvider>
  );
}
